module.exports = __webpack_public_path__ + "img/popup-game-sucai.9c92eee5.png";